<ng-container [formGroup]="form">
    <wdx-form-field
        class="d-block mb-5"
        [legend]="TRANSLATION_DOC_CHECKLIST_DOC_TYPE | translateTokenisedString"
        [isRequired]="true"
        [labelForId]="documentRequirementId + '-documentCode'"
    >
        <ng-select
            bindLabel="name"
            bindValue="code"
            placeholder="Select"
            [formControl]="documentTypeCodeControl"
            [labelForId]="documentRequirementId + '-documentCode'"
            [items]="documentTypes$ | ngrxPush"
            [clearable]="false"
            data-cy="dropdown-documentTypes"
        >
        </ng-select>
    </wdx-form-field>

    @if (documentTypeCodeControl?.value) {
        <atom-async-data [isLoading]="!(documentTemplates$ | ngrxPush)">
            @if ((documentTemplates$ | ngrxPush)?.length > 0) {
                <wdx-form-field
                    [legend]="
                        TRANSLATION_DOC_CHECKLIST_DOC_TEMPLATE
                            | translateTokenisedString
                    "
                    [isRequired]="true"
                >
                    <wdx-radio-tile-group>
                        @for (
                            documentTemplate of documentTemplates$ | ngrxPush;
                            track $index
                        ) {
                            <wdx-radio-tile
                                class="w-50 mb-2"
                                [label]="documentTemplate.name"
                                [subLabel]="documentTemplate?.languageFullName"
                                [value]="documentTemplate.id"
                            >
                                <input
                                    type="radio"
                                    formControlName="documentTemplateId"
                                    [value]="documentTemplate.id"
                                />
                                <wdx-icon
                                    scale="1.75"
                                    [icon]="
                                        (
                                            documentTemplate.fileType
                                            | fileTypeAsIcon: true
                                        )?.icon
                                    "
                                ></wdx-icon>
                            </wdx-radio-tile>
                        }</wdx-radio-tile-group
                ></wdx-form-field>
            } @else {
                <atom-feature-svg class="col-12" [svg]="FEATURE_SVG.NoListData">
                    <div class="text-center">
                        <span class="d-block mb-1"
                            >No templates found for
                            {{ documentTypeCodeControl?.value }}.</span
                        >
                    </div>
                </atom-feature-svg>
            }
        </atom-async-data>
    }
</ng-container>
